$(function() {
    $('.deleteOrder').click(function () {
        var idPed = this.id;
        swal({
            title: "¿Seguro de hacer esto?",
            text: "",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    $.ajax({
                        url: https + "deleteOrder",
                        method: "POST",
                        data: {id: idPed, action: "deleteOrder"},
                        success: function (data) {
                            if ($.trim(data) == "1") {
                                location.reload()
                            } else {
                                swal({
                                    text: "Upps, ha ocurrido un error",
                                    icon: imageURL,
                                    button: "OK!",
                                });
                            }
                        }
                    });
                } else {
                    return false;
                }
            });
    });

    $('.deleteTaller').click(function () {
        var idTaller = this.id;
        swal({
            title: "¿Seguro de hacer esto?",
            text: "",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    $.ajax({
                        url: https + "deleteTaller",
                        method: "POST",
                        data: {id: idTaller, action: "deleteTaller"},
                        success: function (data) {
                            if ($.trim(data) == "1") {
                                location.reload()
                            } else {
                                swal({
                                    text: "Upps, ha ocurrido un error",
                                    icon: imageURL,
                                    button: "OK!",
                                });
                            }
                        }
                    });
                } else {
                    return false;
                }
            });
    });

    $('.deleteService').click(function () {
        var idService = this.id;
        swal({
            title: "¿Seguro de hacer esto?",
            text: "",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    $.ajax({
                        url: https + "deleteService",
                        method: "POST",
                        data: {id: idService, action: "deleteService"},
                        success: function (data) {
                            if ($.trim(data) == "1") {
                                location.reload()
                            } else {
                                swal({
                                    text: "Upps, ha ocurrido un error",
                                    icon: imageURL,
                                    button: "OK!",
                                });
                            }
                        }
                    });
                } else {
                    return false;
                }
            });
    });
});



